import React, { Component } from 'react';

class ClientTabs extends Component {

  constructor(props) {
    super(props);
    this.state = {
        selectedClient: 'experian',
        clients: [
            { id: 'experian',       name: 'Experian',                       slidePosition: 0},
            { id: 'palazzoversace', name: 'Palazzo Versace Dubai',          slidePosition: 1},
            { id: 'jpmorgan',       name: 'JP Morgan Chase & Co.',          slidePosition: 3},
            { id: 'sky',            name: 'Sky TV',                         slidePosition: 5},
            { id: 'barclays',       name: 'Barclays Investment Bank',       slidePosition: 6},
            { id: 'cisco',          name: 'Cisco Systems',                  slidePosition: 8},
            { id: 'betfair',        name: 'Betfair',                        slidePosition: 9}
        ]
    };
    this.navigateToSlide = this.navigateToSlide.bind(this);
  }

  navigateToSlide(e) {
    e.preventDefault();
    let clientTab       = e.currentTarget,
        clientId        = clientTab.getAttribute('data-client-id'),
        slidePosition   = parseInt(clientTab.getAttribute('data-slide-position'));
    //this.setState({ selectedClient: clientId });
    window.portfolioSwipe.slide(slidePosition, 400);
  }

  clientList = () => {
    let listItems = [];
    for (let i = 0; i < this.state.clients.length; i++) {
        let client = this.state.clients[i];
        listItems.push(<li><a href="#" onClick={this.navigateToSlide} data-slide-position={client.slidePosition} data-client-id={client.id} alt={client.name} title={client.name}>{client.name}</a></li>);
    }
    return listItems;
  }

  render() {
    return (
      <ul data-selected-client={this.state.selectedClient}>
        <li>#mywork</li>
        {this.clientList()}
      </ul>
    );
  }

}

export default ClientTabs;



// WEBPACK FOOTER //
// ./src/components/ClientTabs.js